import classNames from 'classnames'
import moment from 'moment'
import { type ChangeEvent, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { type IUpdateFeedback, type IUnpublishedFeedback } from '@/app/types/doctorsType'
import { Button, Divider, TextArea } from '@/shared'
import { routes } from '@Config/config'

import style from './Item.module.scss'

interface IProps extends IUnpublishedFeedback {
    onRemoveFeedback: (id: string, feedbackId: string, isPublished: boolean) => void
    onPublishFeedback: (dto: IUpdateFeedback) => void
    isFetchingFeedbacks: boolean
}

export const Item = (props: IProps) => {
    const {
        author,
        employeeFio,
        createdAt,
        content,
        employeeId,
        id,
        isPublished,
        onRemoveFeedback,
        onPublishFeedback,
        isFetchingFeedbacks
    } = props

    const [editableContent, setEditableContent] = useState<string>(content)

    const navigate = useNavigate()

    const onHandleIsPublishFeedback = () => {
        onPublishFeedback({ id, content: editableContent, isPublished: true })
    }

    const onHandleRemoveFeedback = () => {
        onRemoveFeedback(employeeId, id, isPublished)
    }

    const onGetDoctorPage = () => {
        navigate(`${routes.DOCS}/${employeeId}`)
    }

    const onChangeEditableContent = (e: ChangeEvent<HTMLTextAreaElement>) => {
        setEditableContent(e.target.value)
    }

    return (
        <div className={style.container}>
            <div className={style.author}>
                <span>{`Отзыв от:`}</span>
                <span className={style.authorData}>{`${author}`}</span>
            </div>
            <div className={style.doctor}>
                <span>{`Отзыв для:`}</span>
                <span className={style.doctorData}>{`${employeeFio}`}</span>
            </div>
            <div className={style.date}>
                <span>{`Дата отзыва:`}</span>
                <span className={style.dateData}>{`${moment(createdAt)
                    .locale('ru')
                    .utc()
                    .format('DD MMMM YYYY')}`}</span>
            </div>
            <Divider />
            <TextArea
                className={style.content}
                value={editableContent}
                onChange={onChangeEditableContent}
                scrollHeight={50}
            />
            <Divider />
            <div className={style.actions}>
                <Button
                    disabled={isFetchingFeedbacks}
                    className={classNames(style.btn, style.publish)}
                    onClick={onGetDoctorPage}
                >
                    Перейти
                </Button>
                <Button
                    disabled={isFetchingFeedbacks}
                    className={classNames(style.btn, style.publish)}
                    onClick={onHandleIsPublishFeedback}
                >
                    Опубликовать
                </Button>
                <Button
                    disabled={isFetchingFeedbacks}
                    className={classNames(style.btn, style.remove)}
                    onClick={onHandleRemoveFeedback}
                >
                    Удалить
                </Button>
            </div>
        </div>
    )
}
